<script>
	import GradientBorder from '../GradientBorder.svelte';

	export let imgSrc = '';
	export let heading = '';
	export let description = '';
	export let url = '';
</script>

<a href={url} target="_blank" rel="noreferrer">
	<div
		class="w-72 my-1 border-fx-grey-500 flex-col justify-center items-center bg-fx-grey-900 p-3 rounded-xl border-[0.5px] hover:border-fx-grey-400 transition-all duration-300"
		id="MoreDropDownItem"
	>
		<div class="flex items-center">
			<img class="w-9 h-9 rounded" loading="lazy" src={imgSrc} alt="dropDownItem" />

			<div class="ml-2">
				<div class="text-sm font-semibold">{heading}</div>
				<div class="text-xs">{description}</div>
			</div>
		</div>
	</div>
</a>
